<script>
  import { user } from "../stores/user.js"; // Your user store
  import { createEventDispatcher } from "svelte";
  const localapi = "https://astro.astrosofica.nl/php/userlogin.php";

  const dispatch = createEventDispatcher();
  // Prop to control visibility from parent
  export let show = false;
  const close = () => {
    dispatch("close");
  };

  let username = "";
  let password = "";
  let errorMessage = "";

  const login = async () => {
    // some form validation.
    if (!username) {
      // Display an error message to the user if the username is empty
      errorMessage = "Gebruikersnaam is vereist!";
      return;
    }
    if (!password) {
      // Display an error message to the user if the password is empty
      errorMessage = "Wachtwoord is vereist!";
      return;
    }
    // Check if username is an email address
    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(username)) {
      // Display an error message to the user if the username is not an email
      errorMessage = "Ongeldig emailadres!";
      return;
    }
    // No errors we can proceed to the API
    const response = await fetch(localapi, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username, password }),
    });

    if (response.ok) {
      const { token, name } = await response.json();
      $user = { name, token, loggedIn: true }; // Set the user state
      close();
      errorMessage = ""; // clear the error message if login is successful
    } else {
      // Display error message from the server to the user
      const errorData = await response.json();
      errorMessage = `Inloggen niet gelukt: ${
        errorData.error || "Unknown error"
      }`;
    }
  };
</script>

<!-- Add wrapper div for modal and backdrop -->
<div class="modal" style="display: {show ? 'flex' : 'none'}">
  <div class="backdrop" on:click={close} on:keydown={close} />
  <div class="content">
    <button class="close-button" on:click={close}>X</button>
    <h2>Inloggen</h2>
    <div class="explain">
      Je kunt inloggen met het account wat je hebt gemaakt op <a
        href="https://account.astrosofica.nl/"
        title="account aanmaken of beheren"
        target="_blank">account.astrosofica.nl</a
      >.
      <br />Een account is NIET nodig voor het gebruik van deze website, het
      enige voordeel is dat je horoscopen kunt bewaren.
    </div>
    <br />
    <form on:submit|preventDefault={login}>
      <label class="labeldiv">
        <div class="labeltext">Emailadres:</div>
        <input type="text" bind:value={username} />
      </label>
      <label class="labeldiv">
        <span class="labeltext">Wachtwoord: </span>
        <input type="password" bind:value={password} />
      </label>
      {#if errorMessage}
        <div id="errormessage">{errorMessage}</div>
      {/if}

      <button class="submitbutton" type="submit">Inloggen</button>
    </form>
    <footer>
      <a
        href="https://account.astrosofica.nl/signup.html"
        title="account aanmaken"
        target="_blank">account aanmaken</a
      >
      ::
      <a
        href="https://account.astrosofica.nl/reset-form.php"
        title="wachtwoord vergeten"
        target="_blank">wachtwoord vergeten</a
      >
    </footer>
  </div>
</div>

<!-- Add styles for modal, backdrop, and content -->
<style>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .content {
    position: relative;
    background: white;
    padding: 2em;
    width: 80%;
    max-width: 500px;
    z-index: 10000;
    border-radius: 5px;
  }

  .close-button {
    position: absolute;
    right: 1em;
    top: 0.5em;
  }

  #errormessage {
    color: #ff0000; /* Red text color */
    background: #ffc1c1; /* Light red background */
    border: 1px solid #ff0000; /* Red border */
    padding: 10px; /* Padding around the text */
    margin: 10px 0; /* Margin above and below the div */
    border-radius: 5px; /* Rounded corners */
    font-size: 1.1em; /* Slightly larger font size */
    text-align: center; /* Centered text */
  }
  .submitbutton {
    margin-top: 10px;
    width: 100%;
    margin: auto;
    text-align: center;
    background-color: #bad095;
  }
  .submitbutton:hover {
    background-color: #dde8ca;
    border-color: darkolivegreen;
  }
  .labeltext {
    width: 40%;
  }
  input {
    width: 60%;
  }
  .labeldiv {
    width: 100%;
    display: flex;
  }
  footer {
    font-size: smaller;
    text-align: center;
  }
  .explain {
    font-size: small;
  }
</style>
